import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Topbar from '../../mini-comp/Topbar';
import Sidebar from '../../mini-comp/Sidebar';
import axios from 'axios';
import Cookies from 'js-cookie';
import API_BASE_URL from '../../../../config/api';
import Swal from 'sweetalert2';
import {
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    OutlinedInput,
    Box,
    Chip
} from '@mui/material';

const CreateNotice = () => {
    const navigate = useNavigate();
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [recipientType, setRecipientType] = useState('all');
    const [departments, setDepartments] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = Cookies.get('token');
                const [deptRes, empRes] = await Promise.all([
                    axios.get(`${API_BASE_URL}/api/v1/employees/department/`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    }),
                    axios.get(`${API_BASE_URL}/api/v1/employees/`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    })
                ]);
                setDepartments(deptRes.data);
                // Ensure employees is an array
                setEmployees(Array.isArray(empRes.data) ? empRes.data : []);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        const token = Cookies.get('token');

        const payload = {
            title,
            content,
            recipient_type: recipientType,
        };

        if (recipientType === 'department') {
            payload.department = selectedDepartment;
        } else if (recipientType === 'individual') {
            payload.recipient_ids = selectedEmployees;
        }

        try {
            await axios.post(`${API_BASE_URL}/api/v1/notices/`, payload, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Notice created successfully!',
                timer: 1500,
                showConfirmButton: false
            });

            navigate('/hr/notices');
        } catch (error) {
            console.error('Error creating notice:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to create notice. Please try again.'
            });
        } finally {
            setSubmitting(false);
        }
    };

    const handleEmployeeChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedEmployees(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    return (
        <div>
            <Topbar />
            <Sidebar />

            <>{ /* app-content-area-start */}
                <div className="app-content-area">
                    <div className="app-content-wrap">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="page-title-box d-flex-between flex-wrap gap-15">
                                        <h1 className="page-title fs-18 lh-1">Create Notice</h1>
                                    </div>
                                </div>

                                <div className="col-xl-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit}>
                                                <div className="mb-3">
                                                    <label htmlFor="title" className="form-label">Title <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="title"
                                                        value={title}
                                                        onChange={(e) => setTitle(e.target.value)}
                                                        required
                                                        placeholder="Notice Title"
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="content" className="form-label">Content <span className="text-danger">*</span></label>
                                                    <textarea
                                                        className="form-control"
                                                        id="content"
                                                        rows="5"
                                                        value={content}
                                                        onChange={(e) => setContent(e.target.value)}
                                                        required
                                                        placeholder="Write your notice here..."
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="recipientType" className="form-label">Recipient Type <span className="text-danger">*</span></label>
                                                    <select
                                                        className="form-select"
                                                        id="recipientType"
                                                        value={recipientType}
                                                        onChange={(e) => setRecipientType(e.target.value)}
                                                    >
                                                        <option value="all">All Employees</option>
                                                        <option value="department">Specific Department</option>
                                                        <option value="individual">Individual Employees</option>
                                                    </select>
                                                </div>

                                                {recipientType === 'department' && (
                                                    <div className="mb-3">
                                                        <label htmlFor="department" className="form-label">Select Department <span className="text-danger">*</span></label>
                                                        <select
                                                            className="form-select"
                                                            id="department"
                                                            value={selectedDepartment}
                                                            onChange={(e) => setSelectedDepartment(e.target.value)}
                                                            required
                                                        >
                                                            <option value="">Choose a department...</option>
                                                            {departments.map(dept => (
                                                                <option key={dept.id} value={dept.id}>{dept.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )}

                                                {recipientType === 'individual' && (
                                                    <div className="mb-3">
                                                        <label className="form-label">Select Employees <span className="text-danger">*</span></label>
                                                        <FormControl fullWidth>
                                                            <Select
                                                                labelId="multiple-chip-label"
                                                                id="multiple-chip"
                                                                multiple
                                                                value={selectedEmployees}
                                                                onChange={handleEmployeeChange}
                                                                input={<OutlinedInput id="select-multiple-chip" />}
                                                                renderValue={(selected) => (
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                        {selected.map((value) => {
                                                                            const emp = employees.find(e => e.id === value);
                                                                            return (
                                                                                <Chip key={value} label={emp ? `${emp.first_name} ${emp.last_name}` : value} />
                                                                            )
                                                                        })}
                                                                    </Box>
                                                                )}
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        borderColor: '#e5e7eb', // Match BS border color
                                                                    },
                                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                                        borderColor: '#e5e7eb',
                                                                    },
                                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                        borderColor: '#86b7fe', // Match BS focus color (approx)
                                                                        borderWidth: '1px',
                                                                        boxShadow: '0 0 0 .25rem rgba(13,110,253,.25)'
                                                                    },
                                                                }}
                                                            >
                                                                {employees.map((emp) => (
                                                                    <MenuItem key={emp.id} value={emp.id}>
                                                                        {emp.first_name} {emp.last_name} ({emp.email})
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                )}

                                                <div className="mt-4">
                                                    <button type="submit" className="btn btn-primary" disabled={submitting}>
                                                        {submitting ? 'Creating...' : 'Create Notice'}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { /* app-content-area-end */}</>

        </div>
    )
}

export default CreateNotice
